export default "__VITE_ASSET__Mr8DgHAF__"